import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import DrillDown from '../DrillDown';

class DrillDownField extends Component {

  fieldOnChangeHandler(fieldData){
    console.log(fieldData);
    const {changeHandler} = this.props;
    if(fieldData) {
      const fieldCount = fieldData.length;
      if(fieldCount > 0) {
          const obj = fieldData[fieldCount-1];
          const id = obj.id;
          const fieldName = obj.field_name;
          let absoluteWindow = '';
          let lookupFieldId = '';
          fieldData.map((arr,i) => {
              if(arr.lookUpName) {
                  absoluteWindow += i === 0 ? arr.lookUpName : '.'+arr.lookUpName;
                  lookupFieldId = arr.id;
              }
          })

          const val = {
            tabledescriptor_id:id,
            name:fieldName,
            absolute_window:absoluteWindow,
            absolute_lookup_field_id:lookupFieldId
          }
          changeHandler(val);
      }
    }
    
  } 

  render() {
    const {value,drillId,fieldDetails,changeHandler} = this.props;
    let attr = setAndGetAttributes(this.props);
    
    return (
      <Wrp>
        <DrillDown selectedValue={value} drillId={drillId} fieldDetails={fieldDetails} selectHandler={e=>this.fieldOnChangeHandler(e)}>
                <input type="text" className="form-control col custom-arrow"  />
        </DrillDown>
      </Wrp>        
    );
  }
}

DrillDownField.defaultProps = {
  isMandatory:false,
  className: 'form-control'
}

export default DrillDownField;